import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import {Router} from 'react-router-dom'
import store from './redux/store'
import AppContainer from "./containers/layout/AppContainer";
import {getAirRouterAndStore} from "./api-services/home-service";

const createHistory = require('history').createBrowserHistory;
export const history = createHistory();

history.listen((location) => {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        window.dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', 'UA-134441135-1', {'page_path': location.pathname});

});

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <AppContainer/>
        </Router>
    </Provider>,
    document.getElementById('root')
);
getAirRouterAndStore()
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
